import React from "react"
import { ImCross } from "react-icons/im"
import { type Props } from "./_types"
const IconDeleteCross: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <ImCross size={size} color={color} />
}

export default IconDeleteCross
